import { schema } from 'normalizr';

const statistic = new schema.Entity('statistics');

export const statistics = new schema.Array(statistic);

export default statistic;
